import React from 'react';
import { connect } from 'react-redux';
import styles from './Common.module.css'
import { PatientCareCenterNoteChargesGroupRow } from './GroupRow';

class PatientCareCenterNoteChargesGroupOther extends React.Component {

    render() {
        if (this.props.activities.length > 0) {
            return (
                <div>
                    <div className={styles.row}>
                        <span className={styles.col1} >
                            <b>Other</b>
                        </span>
                        <span className={styles.col2}>
                            <div className={styles.int_field}>
                            </div>
                        </span>
                    </div>

                    {Object.keys(this.props.activities)
                        .map(key => {
                            const act = this.props.activities[key];
                            return (
                                <PatientCareCenterNoteChargesGroupRow
                                    key={act.id}
                                    id={act.id}
                                    table='MLOTHER'
                                    prefix='XLOE'
                                    noteId={this.props.noteId}
                                    activity={act.activity}
                                    selected={act.selected}
                                />

                            )
                        })
                    }

                </div>
            );
        } else {
            return (<span />);
        }
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));

    let activities = Object.keys(state.entities.notes.MLOTHER)
        .filter(key => {
            return (state.entities.notes.MLOTHER[key].XLOEXLNO === xlno &&
                state.entities.notes.MLOTHER[key].XLOEPERFORMED === true &&
                Object.keys(state.entities.masterData.MLMASTEROTHER)
                    .find(x => state.entities.masterData.MLMASTEROTHER[x].OENO === state.entities.notes.MLOTHER[key].XLOEOENO &&
                        state.entities.masterData.MLMASTEROTHER[x].OECODE === '97150'
                    ) === undefined
                &&
                Object.keys(state.entities.masterData.MLMASTEROTHER)
                    .find(x => {
                        if (state.entities.masterData.MLMASTEROTHER[x].OENO === state.entities.notes.MLOTHER[key].XLOEOENO) {
                            var code = parseInt(state.entities.masterData.MLMASTEROTHER[x].OECODE);
                            if (!isNaN(code)) { // IS number
                                // code >= 97032 && code <= 97542 && code != 97150
                                if (code >= 97032 && code <= 97542 && code !== 97150) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    })
            )
        })
        .sort((a, b) => state.entities.notes.MLOTHER[a].XLOENO - state.entities.notes.MLOTHER[b].XLOENO)
        .map(key => {
            let act = state.entities.notes.MLOTHER[key].XLOEOENO ?
                state.entities.masterData.MLMASTEROTHER[state.entities.notes.MLOTHER[key].XLOEOENO].OENAME + ' - ' +
                state.entities.masterData.MLMASTEROTHER[state.entities.notes.MLOTHER[key].XLOEOENO].OECODE + ' - ' : '<Activity Not Defined> - ';
            act += state.entities.notes.MLOTHER[key].XLOEACTIVITY ?
                ' - ' + state.entities.notes.MLOTHER[key].XLOEACTIVITY : '';
            return {
                activity: act,
                id: state.entities.notes.MLOTHER[key].XLOENO,
                selected: state.entities.notes.MLOTHER[key].XLOEISGROUP
            };
        });


    return {
        noteId,
        noteType,
        xlno,
        activities
    };
}

const connectedPatientCareCenterNoteChargesGroupOther = connect(mapStateToProps)(PatientCareCenterNoteChargesGroupOther);
export { connectedPatientCareCenterNoteChargesGroupOther as PatientCareCenterNoteChargesGroupOther };

